import { Box, Grid } from "@mui/material";
import { graphql } from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";
import { InternBrandBilling_brand$key } from "./__generated__/InternBrandBilling_brand.graphql";
import nullthrows from "../../utils/nullthrows";
import InternBrandBillingOneTimePurchaseCard from "./InternBrandBillingOneTimePurchaseCard";
import InternBrandBillingRecurringSubCard from "./InternBrandBillingRecurringSubCard";

const brandFragment = graphql`
  fragment InternBrandBilling_brand on BrandType {
    id
    billingConfig {
      ...InternBrandBillingRecurringSubCard_billingConfig
    }
    ...InternBrandBillingOneTimePurchaseCard_brand
  }
`;

const InternBrandBilling = ({
  brand: brandKey,
}: {
  brand: InternBrandBilling_brand$key;
}) => {
  const brand = useFragment(brandFragment, brandKey);
  const billingConfig = nullthrows(brand.billingConfig);

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12} lg={6}>
          <InternBrandBillingRecurringSubCard
            billingConfig={billingConfig}
            brandID={brand.id}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <InternBrandBillingOneTimePurchaseCard brand={brand} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default InternBrandBilling;
